<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Usuário: #{{ route.params.id }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'usun-lista-usuarios' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div>
      <div class="row col-12 q-mt-lg">
        <q-tabs
          v-model="tab"
          style="padding: 0px; margin: 0px"
          dense
          class="q-mt-xl col text-grey-7"
          active-color="black"
          no-caps
          active-bg-color="brand-11"
          indicator-color="transparent"
          align="justify"
        >
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            name="informacoesUsuario"
            label="Informações do Usuário"
          />
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            class="q-ml-sm q-mr-sm"
            name="biometria"
            label="Biometria"
          />
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            class="q-ml-sm q-mr-sm"
            name="biometriaFacial"
            label="Facial"
          />
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            name="retiradaTablet"
            label="Retirada Tablet"
          />
        </q-tabs>
      </div>
      <q-tab-panels class="row col-12 q-mt-xl" v-model="tab">
        <q-tab-panel name="informacoesUsuario">
          <EdicaoInformacoesUsuario />
        </q-tab-panel>
        <q-tab-panel name="biometria">
          <BiometriaUsuario />
        </q-tab-panel>
        <q-tab-panel name="biometriaFacial">
          <BiometriaFacialUsuario />
        </q-tab-panel>
        <q-tab-panel name="retiradaTablet">
          <RetiradaTabletPin />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </q-page>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";

import EdicaoInformacoesUsuario from "../components/EdicaoInformacoesUsuario.vue";
import BiometriaUsuario from "../components/BiometriaUsuario.vue";
import RetiradaTabletPin from "../components/RetiradaTabletPin.vue";
import BiometriaFacialUsuario from "../components/BiometriaFacialUsuario.vue";

const tab = ref("informacoesUsuario");
const route = useRoute();
</script>

<style scoped>
a {
  text-decoration: none;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.q-tab-panel {
  padding: 0px;
  margin: 0px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
